import React, { useEffect, useState } from "react";
import "./JoinRoom.css";
import joinImg from "../../assets/images/join-room.png";

const JoinRoom = ({ isLoading = false, isDisabled = false, onJoin, resetToken = 0 }) => {
  const [roomCode, setRoomCode] = useState("");

  useEffect(() => { if (resetToken) setRoomCode(""); }, [resetToken]);

  const handleSubmit = () => {
    if (!roomCode.trim() || isDisabled) {
      return;
    }

    onJoin?.(roomCode.trim());
  };

  return (
    <div className="join-room-ui">
      <div className="create-room-ui__illustration">
        <img src={joinImg} alt="" />
      </div>

      <div className="join-room-ui__content">
        <h2 className="create-room-ui__title">Join Room</h2>
        <div className="create-room-ui__title-line"></div>
        <p className="create-room-ui__subtitle">Enter room code to join battle</p>

        <div className="join-room-ui__action-row">
          <div className="join-room-ui__input-wrapper">
            <input
              type="text"
              placeholder="Enter Room Code"
              className="join-room-ui__input"
              value={roomCode}
              onChange={(event) => setRoomCode(event.target.value.replace(/[^0-9]/g, ""))}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  handleSubmit();
                }
              }}
            />
          </div>

          <button
            type="button"
            className="create-room-ui__create-btn"
            onClick={handleSubmit}
            disabled={isLoading || isDisabled || !roomCode.trim()}
          >
            <span>{isLoading ? "Joining..." : "Join Room"}</span>
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default JoinRoom;
